import { render, staticRenderFns } from "./ThePrednosti.vue?vue&type=template&id=91e822ce&scoped=true&"
import script from "./ThePrednosti.vue?vue&type=script&lang=js&"
export * from "./ThePrednosti.vue?vue&type=script&lang=js&"
import style0 from "./ThePrednosti.vue?vue&type=style&index=0&id=91e822ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91e822ce",
  null
  
)

export default component.exports